module.exports = __webpack_public_path__ + "static/media/sql.e30ffe88.png";